export const styles = {
	ideationTypography: {
		fontSize: '1.4rem',
		letterSpacing: '1px',
		marginLeft: {
			xs: '0',
			sm: '2rem',
			md: '5rem',
		},
		marginTop: {
			xs: '4rem',
			md: '2.2rem',
		},
		marginBottom: '.8rem',
		color: 'black',
	},
	cautionTypography: {
		color: 'black',
		opacity: 0.6,
	},
	chip: {
		paddingX: '0.5rem',
		color: 'black',
	},
	editButtonsContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		gap: '2rem',
	},
	generateButton: {
		width: { xs: '100%', sm: '77%' },
		height: { xs: '7rem', sm: 'fit-content' },
	},
	inputLabel: {
		color: 'black',
		opacity: '23%',
	},
	mainBox: {
		'.ProseMirror': {
			border: '1.5px solid var(--color-gray-4)',
		},
		'.ProseMirror-focused': {
			border: '2.5px solid var(--color-gray-4)',
		},
		display: 'flex',
		marginTop: {
			xs: '1rem',
			md: '0',
		},
	},
	marginLeft: {
		xs: '0',
		md: '5red',
	},
	richTextField: {
		background: '#FFE9C9',
		borderLeft: 'none',
		borderRight: 'none',
		borderTop: 'none',
	},
	firstRichTextFieldDescription: {
		marginTop: {
			md: '-1.1rem',
		},
		color: 'black',
		opacity: 0.87,
	},
	richTextFieldDescription: {
		color: 'black',
		opacity: 0.87,
	},
	richTextFieldGrid: {
		minHeight: '16rem',
		overflow: 'hidden',
		overflowY: 'scroll',
		color: 'black',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #E65C00 0%, #F9D423 100%)',
		marginRight: '2rem',
		marginLeft: {
			xs: '0',
			md: '5rem',
		},
		marginTop: {
			xs: '2rem',
			md: '1rem',
		},
	},
	submitButtonBox: {
		flexDirection: {
			xs: 'column-reverse',
			sm: 'row',
		},
		display: 'flex',
		gap: '2rem',
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: 'black',
				opacity: '23%',
			},
		},
	},
	typographyBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: '1',
		paddingY: {
			sm: '2rem',
		},
	},
	// sideBar: {
	// 	display: { xs: 'none', sm: 'block' },
	// 	minWidth: '4px',
	// 	background: 'linear-gradient(180deg, #E65C00 0%, #F9D423 100%)',
	// },
	// submitContainer: {
	// 	alignItems: 'center',
	// 	display: 'flex',
	// 	gap: '1.4rem',
	// },
	// submitButton: {
	// 	'&:disabled': {
	// 		backgroundColor: 'primary.disabled',
	// 		color: '#FFF',
	// 	},
	// 	'&:hover': {
	// 		backgroundColor: 'primary.main',
	// 		color: '#FFF',
	// 	},
	// 	backgroundColor: 'primary.main',
	// 	borderRadius: 0,
	// 	color: '#FFF',
	// 	width: '15.5rem',
	// },
	// sectionText: {
	// 	color: 'text.secondary',
	// 	fontStyle: 'italic',
	// 	maxHeight: '25rem',
	// },
	// cautionText: {
	// 	opacity: 0.6,
	// },
	// header: {
	// 	marginY: '2rem',
	// },
	// exampleIdeasBox: {
	// 	padding: '1rem',
	// 	backgroundColor: '#FFE9C9',
	// 	color: 'black',
	// },
	// listItem: {
	// 	margin: '10px 0',
	// },
	// proseMirror: {
	// 	'.ProseMirror': {
	// 		border: '1.5px solid #0000003B',
	// 		borderBottomLeftRadius: '4px',
	// 		borderBottomRightRadius: '4px',
	// 	},
	// 	'.ProseMirror-focused': {
	// 		border: '2.5px solid #0000003B',
	// 		borderBottomLeftRadius: '4px',
	// 		borderBottomRightRadius: '4px',
	// 	},
	// },
	// mainContainer: {
	// 	display: 'flex',
	// 	flexDirection: 'column',
	// 	flexGrow: '1',
	// 	gap: '3.2rem',
	// },
	// threeColumnLayout: {
	// 	display: 'flex',
	// 	gap: '32px',
	// 	flexDirection: {
	// 		lg: 'row',
	// 		md: 'row',
	// 		sm: 'column',
	// 		xs: 'column',
	// 	},
	// },
	// columnBox: {
	// 	display: 'flex',
	// 	flexDirection: 'column',
	// 	gap: '16px',
	// 	width: '100%',
	// },
	// gridItem: {
	// 	minHeight: {
	// 		xs: '15rem',
	// 		sm: '20rem',
	// 	},
	// },
	// richTextField: {
	// 	background: '#FFE9C9',
	// 	borderLeft: 'none',
	// 	borderRight: 'none',
	// 	borderTop: 'none',
	// },
	// unsureText: {
	// 	fontSize: '1.8rem',
	// 	color: '#000000DE',
	// },
	// dropdownContainer: {
	// 	display: 'flex',
	// 	gap: '32px',
	// 	marginTop: '8px',
	// 	flexDirection: {
	// 		lg: 'row',
	// 		md: 'row',
	// 		sm: 'column',
	// 		xs: 'column',
	// 	},
	// },
	// buttonContainer: {
	// 	display: 'flex',
	// 	flexDirection: {
	// 		xs: 'column',
	// 		sm: 'row',
	// 	},
	// 	gap: '1.6rem',
	// },
}
